import React from 'react';
import { makeHierarchicalBreadcrumbsFromURLPath } from "@/presentation/components/commons/breadcrumbs";
import { IdentitiesHandlersProvider } from "@/presentation/providers";
import IdentitiesView from "@/presentation/pages/identities/identities-view";
import { KiverascapeLayout } from '@/presentation/layouts/kiverascape-layout';
import { Flashbar } from "@cloudscape-design/components-themed/components";
import { useNotifications } from "@/presentation/providers/notifications-provider";
import { useLocation } from "react-router-dom";
import { ErrorBoundaryContextProvider } from '@/presentation/providers/error-boundary-provider';
const MakeIdentitiesView = () => {
    const { notifications } = useNotifications();
    const location = useLocation();
    const breadCrumbs = makeHierarchicalBreadcrumbsFromURLPath(location === null || location === void 0 ? void 0 : location.pathname);
    return (React.createElement(ErrorBoundaryContextProvider, null,
        React.createElement(KiverascapeLayout, { breadcrumbMenu: breadCrumbs, notifications: React.createElement(Flashbar, { items: notifications, 
                // @ts-ignore
                stackItems: true }), content: React.createElement(IdentitiesHandlersProvider, null,
                React.createElement(IdentitiesView, null)), contentType: "default" })));
};
export default MakeIdentitiesView;
